<h1 class="text-center">{{ 'SELLER_COLLECT_DATA.HEADER.PERSONAL_DETAILS' | translate }}</h1>
<p class="text-center">{{ 'SELLER_COLLECT_DATA.TEXT.COMPLETE_FORM_DISCLAIMER' | translate }}</p>

<form [formGroup]="formGroup" (ngSubmit)="submit()" class="flex flex-column gap-3">
  <div class="flex flex-column gap-2">
    <label for="firstName">{{ 'SELLER_COLLECT_DATA.LABEL.FIRST_NAME' | translate }}</label>
    <input pInputText formControlName="firstName" id="firstName" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="lastName">{{ 'SELLER_COLLECT_DATA.LABEL.LAST_NAME' | translate }}</label>
    <input pInputText formControlName="lastName" id="lastName" />
  </div>

  <div class="flex flex-column gap-2">
    <label for="email">{{ 'SELLER_COLLECT_DATA.LABEL.EMAIL' | translate }}</label>
    <input pInputText formControlName="email" id="email" type="email" />
  </div>

  <div class="flex flex-column gap-2">
    <label for="socialId">{{ 'SELLER_COLLECT_DATA.LABEL.ID_NUMBER' | translate }}</label>
    <input pInputText formControlName="socialId" id="socialId" />
  </div>
  <div class="flex flex-column gap-2">
    <label for="phone">{{ 'SELLER_COLLECT_DATA.LABEL.PHONE' | translate }}</label>
    <ngx-intl-tel-input
      formControlName="phone"
      id="phone"
      [preferredCountries]="[CountryISO.Israel]"
      [selectedCountryISO]="CountryISO.Israel"
      [numberFormat]="PhoneNumberFormat.National"
      [phoneValidation]="false"
    ></ngx-intl-tel-input>
  </div>

  <div class="flex justify-content-between">
    <button pButton class="simple-button" [disabled]="formGroup.invalid">
      {{ 'SELLER_COLLECT_DATA.LABEL.CONTINUE' | translate }}
    </button>
  </div>
</form>
